import { type FC } from 'react';

import { CarouselMainContainer } from 'shared/components/Carousel';
import { AdfoxPixelContainer } from 'shared/containers/AdfoxPixel';
import { Promos } from 'shared/containers/Promos';
import { MortgageCalculatorContainer } from 'shared/packages/mortgage-calculator';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { AboutContainer } from '../About';
import { AwardsContainer } from '../Awards';
import { ContentWrapper } from '../ContentWrapper';
import { FactsContainer } from '../Facts';
import { HeaderContainer } from '../Header';
import { PikHistoryContainer } from '../PikHistory';
import { PikInNumbersContainer } from '../PikInNumbers';
import { BLOCK_ID as PIK_IN_NUMBERS_V2_BLOCK_ID, PikInNumbersV2Container } from '../PikInNumbersV2';
import { PikProjectsContainer } from '../PikProjects';
import { RatingsContainer } from '../Ratings';
import { SeriaPlusContainer } from '../SeriaPlus';
import { BLOCK_ID as SERIA_PLUS_V2_BLOCK_ID, SeriaPlusV2Container } from '../SeriaPlusV2';
import { EnvironmentForLifeAndBusinessContainer, ProductFeaturesOfTheQuarters } from '../SliderBlockTypeOne';
import { BLOCK_ID as SMART_HOME_BLOCK_ID, SmartHomeContainer } from '../SmartHome';

export const ApplicationContent: FC = () => {
  const { config } = useApplicationContext();

  const designV2EnabledBlocks = config.get<string[]>('Martech.PikLanding.DesignV2.EnabledBlocks') ?? [];

  const isBlockV2Enabled = (blockId: string): boolean => designV2EnabledBlocks.includes(blockId);

  return (
    <div data-testid="ApplicationContent">
      <CarouselMainContainer />
      <ContentWrapper>
        <HeaderContainer />
        <FactsContainer />
        <Promos />
        <PikProjectsContainer />
        {isBlockV2Enabled(SERIA_PLUS_V2_BLOCK_ID) ? <SeriaPlusV2Container /> : <SeriaPlusContainer />}
        <MortgageCalculatorContainer />
        {isBlockV2Enabled(PIK_IN_NUMBERS_V2_BLOCK_ID) ? <PikInNumbersV2Container /> : <PikInNumbersContainer />}
        <EnvironmentForLifeAndBusinessContainer
          isDesignV2Enabled={isBlockV2Enabled('environment-for-life-and-business')}
        />
        <ProductFeaturesOfTheQuarters />
        {isBlockV2Enabled(SMART_HOME_BLOCK_ID) ? <SmartHomeContainer /> : null}
        <PikHistoryContainer />
        <RatingsContainer />
        <AwardsContainer />
        <AboutContainer />
        <AdfoxPixelContainer />
      </ContentWrapper>
    </div>
  );
};
